import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { RuleModel, RuleStipModel } from '../model/rule.model';
import { RuleService } from '../service/rule.service';
import { Store } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { AddStipRule } from '../state/action/rules.actions';
import { QualityState } from '../../state/quality.state';
import { OrderDetailModel } from '../../state/model/order-detail.model';
import { takeUntil } from 'rxjs/operators';
import { OverviewSubHeaderService } from '../../overview/sub-header/service/overview-sub-header.service';

@Component({
	selector: 'cv-rule-stip-create-component',
	templateUrl: './rule-stip-create.component.html',
	styleUrls: ['./rule-stip-create.component.scss']
})
export class RuleStipCreateComponent implements OnInit, OnDestroy {
	@Input() rule: RuleModel;
	@Output() cancel: EventEmitter<any> = new EventEmitter<any>();
	@Output() saved: EventEmitter<RuleStipModel> = new EventEmitter<RuleStipModel>();
	@Output() failed: EventEmitter<any> = new EventEmitter<any>();

	orderDetail$: Observable<OrderDetailModel> = this.store.select(QualityState.getOrderDetail);

	public stips: RuleStipModel[];
	public stipSelected: RuleStipModel;
	private originalStipText: string;
	public stipText: string;
	public saving: boolean;

	get lockedBy(): any {
		return this.subheaderService.orderLocked;
	}

	private orderDetailModel: OrderDetailModel;
	private atComponentDestroy = new Subject();

	constructor(
		private ruleService: RuleService,
		private store: Store,
		private subheaderService: OverviewSubHeaderService
	) {
		this.orderDetail$
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((orderDetailModel: OrderDetailModel) => {
				this.orderDetailModel = orderDetailModel;
			});
		this.saving = false;
		this.stips = [];
	}

	ngOnInit(): void {

		 // no longer need to ask for the rule to the back
		 this.stips = this.rule.availableStips;
		// this.ruleService.getStips(encodeURIComponent(this.rule.name)).subscribe(result => {
		// 	this.stips = result.data;
		// });
	}

	/**
	 * Creates the new Stip.
	 */
	public addStip(): void {
		this.saving = true;
		const orderId = this.orderDetailModel.id;
		const documentId = this.orderDetailModel.documentId;
		const ruleStip = {
			id: this.stipSelected.stipId,
			// id: this.stipSelected.id,
			stipulation: this.stipText,
			overwritten: this.isStipTextOverwritten()
		};
		this.ruleService
			.createStip(orderId, documentId, this.rule.name, ruleStip)
			.subscribe({
				next: (response: any) => {
					if (response.isValid) {
						const stips = {
							id: response.key,
							stipulation: ruleStip.stipulation,
							created: new Date(),
							updated: null,
							overwritten: ruleStip.overwritten,
							 ruleName: this.rule.name
						};
						this.store.dispatch(new AddStipRule({ ruleName: this.rule.name, stips }));
						this.saved.emit(stips);
					} else {
						this.failed.emit();
					}
					this.saving = false;
				},
				error: (error: any) => {
					this.saving = false;
				}
			});
	}

	/**
	 * Set the selected stip.
	 * @param $event
	 */
	public onStipSelected($event: RuleStipModel): void {
		this.stipSelected = $event;
		if (this.stipSelected) {
			this.originalStipText = this.stipSelected.stipulation;
			this.stipText = this.stipSelected.stipulation;
		} else {
			this.stipText = '';
		}
	}

	/**
	 * On Cancel/Close panel form.
	 */
	public onCancel(): void {
		this.cancel.emit();
	}

	/**
	 * Checks if user has overwritten the original stip text.
	 */
	protected isStipTextOverwritten(): boolean {
		return this.originalStipText !== this.stipText;
	}

	/**
	 * Close all when the element is destroyed
	 * in case a Sub Component remains visible
	 */
	ngOnDestroy(): void {
		// Globally Destroy anything attached to it
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
